/*
 Generated by typeshare 1.7.0
*/

export interface DbKey<T> {
	idx: number;
}

export interface PosPrev {
	pos: DbKey<Pos>;
	next_idx: number;
}

export enum Player {
	Black = "Black",
	White = "White",
}

export interface Loc {
	row: number;
	col: number;
}

export interface Stone {
	player: Player;
	loc: Loc;
}

export interface Pos {
	prev?: PosPrev;
	next: string;
	moves: Stone[];
}

export interface GameEvent {
	pos: DbKey<Pos>;
	stone: Stone;
	is_current: boolean;
	text: string;
}

export interface FrontendGoban {
	goban_state: Stone[];
	last_move?: Stone;
	variation: Stone[];
}

export interface FrontendGameMap {
	events: GameEvent[][];
}

export interface Game {
	root_pos: string;
	pos: string;
	name: string;
}

export interface TmpKeyValGame {
	key: DbKey<Game>;
	val: Game;
}

export interface FrontendGames {
	games: TmpKeyValGame[];
}

export interface BackendToFrontend {
	goban: FrontendGoban;
	games: FrontendGames;
	game_map: FrontendGameMap;
}

export type FrontendToBackend = 
	| { enum_tag: "GobanClick", content: {
	loc: Loc;
}}
	| { enum_tag: "GameClick", content: {
	game: DbKey<Game>;
}}
	| { enum_tag: "EventClick", content: {
	pos: DbKey<Pos>;
}}
	| { enum_tag: "KeyboardPress", content: {
	key: string;
}};

